"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_LOAD_MORE_HEIGHT = exports.LIST_SECTION_LABEL_HEIGHT = exports.LIST_DIVIDER_HEIGHT = exports.LIST_ITEM_HEIGHT = exports.ROW_OFFSET_PX = void 0;
exports.ROW_OFFSET_PX = 8;
exports.LIST_ITEM_HEIGHT = 68;
exports.LIST_DIVIDER_HEIGHT = 24;
exports.LIST_SECTION_LABEL_HEIGHT = 20;
exports.LIST_LOAD_MORE_HEIGHT = 1;
